import "./movements.css";

import { Modal, Tabs } from "@sede-x/shell-ds-react-framework";
import { TMovementGroup } from "ticketing/ticketing.types";
import { MovementAlerts } from "./MovementAlerts";
import { MovementDeliveryEvents } from "./MovementDeliveryEvents";
import { MovementMeasures } from "./MovementMeasures";

const MovementAspectContainer = ({
  movementGroup,
  onClose,
  editDisabled
}: {
  movementGroup: TMovementGroup;
  onClose: () => void;
  editDisabled: boolean;
}) => {
  // DEV NOTES: for the code block below
  // in the case of a double play - since all the delivery events must be the same
  // we only show the delivery events for the selected leg
  // when a change is made we need to mimic the change for the other legs

  const handleClose = () => {
    onClose();
  };

  //DEV NOTES - PLEASE READ
  /**
   Bit of a unique situation here - while a movement group has more than one leg/movement/nom - 
   the delivery events for each of these MUST be the same
   So the prop passed to the delivery event details component is the attribute
   deliveryEvents of only the FIRST movement
   ? can we assume that all the del event types for a movement are unique, or is the combination of event type and event date is unique - YES - confirmed with Jose
   */
  const items = [
    {
      label: "Delivery Events",
      key: "delivery-events",
      children: (
        <MovementDeliveryEvents
          movementGroup={movementGroup}
          onClose={onClose}
          editDisabled={editDisabled}
        />
      )
    },
    {
      label: "Measures",
      key: "measures",
      children: (
        <MovementMeasures
          movementGroup={movementGroup}
          onClose={onClose}
          editDisabled={editDisabled}
        />
      )
    },
    {
      label: "Alerts",
      key: "alerts",
      children: <MovementAlerts movementGroup={movementGroup} onClose={onClose} />
    }
  ];

  return (
    <Modal
      open={true}
      bodyPadding={false}
      onClose={handleClose}
      width={700}
      className="movement-aspect"
      contentScrollable
      title={`Delivery ID: ${movementGroup.movements.at(0)?.enterpriseSystemCode}`}>
      <Tabs
        items={items}
        defaultActiveKey="delivery-events"
        className="movement-aspect-container"
      />
    </Modal>
  );
};

export default MovementAspectContainer;
